const DARK_MODE_ENABLED = "DARK_MODE_ENABLED";
const DARK_MODE_DISABLED = "DARK_MODE_DISABLED";
const DARK_MODE_LOCAL_ANIME_MANAGER = "DARK_MODE_LOCAL_ANIME_MANAGER";

export { DARK_MODE_DISABLED, DARK_MODE_ENABLED, DARK_MODE_LOCAL_ANIME_MANAGER  };
